<template>
    

    <div class="caption-host">
        <div>
            <!-- <img style="width: 16%; margin-left: 18px; float:left" alt="Moresi.com" src="@/assets/logo-moresi-senza-zona-esclusione.png" />-->
            <center><img style="width: 16%" alt="Moresi.com" src="@/assets/logo-moresi-senza-zona-esclusione.png" /></center>

           
        </div>
        <div v-if="!started">
            <h1>Host a new session</h1>

            <!----<div><input type="password" v-model="password" placeholder="Password to host a session" /></div>-->
            <div><input type="text" v-model="name" placeholder="Session Name" id="text" /></div>
            <div>
                Select spoken lanauge:
                <select v-model="fromLanguage">
                    <option v-for="lang in fromLanguages" :value="lang" :key="lang">
                        {{ lang.substring(0, 2) }}
                    </option>
                </select><br />
                <button @click="start">Start</button>
            </div>
        </div>
        <div v-else>
            <div id="qrcode"></div>
            <script type="text/javascript">
                new QRCode(document.getElementById("qrcode"), "https://locarno.moresi.com/join");
            </script>
            <button @click="stop">stop</button>
            <div id="currentSentence" class="caption">
                {{ currentSentence }}
            </div>
        </div>
        <div class="footer">
            
            <div style="text-align:center;">Copyright Moresi.com SA 2024</div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import constants from '../lib/constants'
import Translator from '../lib/translator'
import languageListMixin from '../lib/language-list-mixin'

const passwordKey = 'passwordKey'
const nameKey = 'sessionNameKey'

export default {
  mixins: [languageListMixin],
  data() {
    return {
      key: constants.ttsKey || '',
      password: localStorage.getItem(passwordKey) || '',
      name: window.localStorage.getItem(nameKey) || '',
      region: `${constants.region}`,
      currentSentence: '',
      started: false,
      fromLanguage: 'en-US'
    }
  },
  watch: {
    password(newPassword) {
      window.localStorage.setItem(passwordKey, newPassword);
    },
    name(newName) {
      window.localStorage.setItem(nameKey, newName);
    }
  },
  created() {
    this.translator = new Translator(function (captions) {
      this.currentSentence = captions.original;
      captions.translations.sessionName = this.name;
      console.log(captions);
      axios.post(`${constants.apiBaseUrl}/api/captions`,
        captions.translations);
    }.bind(this))
  },
  methods: {
    start() {
      this.translator.start({
        key: this.key,
        region: this.region,
        fromLanguage: this.fromLanguage,
        toLanguages: this.toLanguages
      })
      this.started = true
    },
    stop() {
      this.started = false
      this.currentSentence = ''
      this.translator.stop()
    }
  },
  beforeDestroy() {
    this.translator.stop()
  }
}
</script>

<style scoped>
input[type=password] {
  width: 600px;
}

.footer
{
  margin-top: 20px;
  position: relative;
  bottom: 0;
  padding: 10px;
}

.footer img
{
  width: 20%;
}
    #nav {
        position: fixed;
        top: 15px;
        width: 100%;
        min-height: 50px;
        z-index: 1000;
        background-color: #fff;
    }
    .caption {
        margin: 28px auto;
        max-width: 1024px;
        font-size: 48px;
        text-align: left;
        padding: 24px;
    }
</style>
